import React from "react"
import './foods.css'

const img_list = [
    'https://cdn.img.tyhjrbl.com/img/202604/02/11582haMSnLfeZ.png',
    'https://cdn.img.tyhjrbl.com/img/202604/02/1159zckzr4Xm3d.png',
    'https://cdn.img.tyhjrbl.com/img/202604/02/11598bmSjGJ7OE.png',
    'https://cdn.img.tyhjrbl.com/img/202604/02/1159fpFU3ejYYs.png',
    'https://cdn.img.tyhjrbl.com/img/202604/02/1159PF8LYlfbeX.png',
    'https://cdn.img.tyhjrbl.com/img/202604/02/11591NxWf7JgHb.png',
    'https://cdn.img.tyhjrbl.com/img/202604/02/1159s3O5X7FQrU.png',
    'https://cdn.img.tyhjrbl.com/img/202604/02/1159gSFoi7aqFO.png',
    'https://cdn.img.tyhjrbl.com/img/202604/02/1159panCxxUayG.png',
    'https://cdn.img.tyhjrbl.com/img/202604/02/1159En8Tp8g7Ov.png',
    'https://cdn.img.tyhjrbl.com/img/202604/02/1159f0x2kEnDEe.png',
    'https://cdn.img.tyhjrbl.com/img/202604/02/1159gvRx5U6tff.png'
]


export default function Foods () {
    return (
        <>
            <div className='foo_box'>
                <div className='one'>
                    {img_list.slice(0, 3).map((value, index) => {
                        return (
                            <div key={index}>
                                <img src={value} alt="" />
                            </div>
                    )})}
                    <div></div>
                </div>
                <div className='two'>
                    {img_list.slice(3, 6).map((value, index) => {
                        return (
                            <div key={index}>
                                <img src={value} alt="" />
                            </div>
                    )})}
                    <div></div>
                </div>
                <div className='three'>
                    {img_list.slice(6, 8).map((value, index) => {
                        return (
                            <div key={index}>
                                <img src={value} alt="" />
                            </div>
                    )})}
                    <div></div>
                    <div></div>
                </div>
                <div className='four'>
                    {img_list.slice(8 , 10).map((value, index) => {
                        return (
                            <div key={index}>
                                <img src={value} alt="" />
                            </div>
                    )})}
                    <div></div>
                    <div></div>
                </div>
                <div className='five'>
                    {img_list.slice(10 , 12).map((value, index) => {
                        return (
                            <div key={index}>
                                <img src={value} alt="" />
                            </div>
                    )})}
                    <div></div>
                    <div></div>
                </div>
            </div>
        </>
    )
}